var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.selectedRow ? _c('BaseModal', {
    on: {
      "close": _vm.closeWorkingHoursModal
    }
  }, [_c('RegisterHoursModal', {
    attrs: {
      "name": _vm.selectedRow.userFullName || '',
      "courseId": _vm.selectedRow.courseId,
      "userId": _vm.selectedRow.userId,
      "isExternalResource": 'courseContractId' in _vm.selectedRow === true,
      "editValues": Object.assign({}, _vm.selectedRow)
    },
    on: {
      "close": _vm.closeWorkingHoursModal,
      "refresh": _vm.loadWorkingHours
    }
  })], 1) : _vm._e(), _c('BaseLayout', {
    staticClass: "px-0",
    scopedSlots: _vm._u([{
      key: "title",
      fn: function fn() {
        return [_c('v-icon', {
          attrs: {
            "left": ""
          },
          on: {
            "click": _vm.navigateToCourseDashboard
          }
        }, [_vm._v("mdi-arrow-left")]), _vm._v(" " + _vm._s(_vm.$route.params.id) + " - " + _vm._s(_vm.course.courseName) + " ")];
      },
      proxy: true
    }, {
      key: "actions",
      fn: function fn() {
        return [_c('v-text-field', {
          staticClass: "mr-5",
          attrs: {
            "append-icon": "mdi-magnify",
            "label": "Søk i arbeidstimer",
            "single-line": "",
            "hide-details": ""
          },
          model: {
            value: _vm.search,
            callback: function callback($$v) {
              _vm.search = $$v;
            },
            expression: "search"
          }
        }), _vm.selectedRows.length > 0 ? _c('BaseTooltipIconButton', {
          attrs: {
            "color": "primary",
            "btnText": "Godkjenn valgte arbeidstimer",
            "icon": "mdi-file-sign",
            "dataCy": "sendButton"
          },
          on: {
            "handleClick": _vm.approveSelectedWorkingHourEntries
          }
        }) : _vm._e()];
      },
      proxy: true
    }])
  }, [[_c('BaseTableFiltered', {
    staticClass: "mt-3",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.workingHours,
      "search": _vm.search,
      "item-key": "id",
      "show-select": "",
      "sort-by": "date",
      "sort-desc": true
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref2) {
              var on = _ref2.on,
                  attrs = _ref2.attrs;
              return [_c('v-icon', _vm._g(_vm._b({
                attrs: {
                  "data-cy": "displayOrder"
                },
                on: {
                  "click": function click($event) {
                    return _vm.displayWorkingHourEntry(item);
                  }
                }
              }, 'v-icon', attrs, false), on), [_vm._v("mdi-open-in-new ")])];
            }
          }], null, true)
        }, [_c('span', [_vm._v("Vis registrering")])]), _c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref3) {
              var on = _ref3.on,
                  attrs = _ref3.attrs;
              return [_c('v-icon', _vm._g(_vm._b({
                on: {
                  "click": function click($event) {
                    return _vm.updateWorkingHours(item);
                  }
                }
              }, 'v-icon', attrs, false), on), [_vm._v("mdi-pencil")])];
            }
          }], null, true)
        }, [_c('span', [_vm._v("Oppdater")])])];
      }
    }, {
      key: "item.date",
      fn: function fn(_ref4) {
        var value = _ref4.value;
        return [_vm._v(" " + _vm._s(_vm.formatLocalizedDate(value)) + " ")];
      }
    }, {
      key: "item.comment",
      fn: function fn(_ref5) {
        var value = _ref5.value;
        return [value ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref6) {
              var on = _ref6.on,
                  attrs = _ref6.attrs;
              return [_c('v-icon', _vm._g(_vm._b({}, 'v-icon', attrs, false), on), [_vm._v("mdi-message")])];
            }
          }], null, true)
        }, [_c('span', [_vm._v(_vm._s(value))])]) : _vm._e()];
      }
    }], null, true),
    model: {
      value: _vm.selectedRows,
      callback: function callback($$v) {
        _vm.selectedRows = $$v;
      },
      expression: "selectedRows"
    }
  })]], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }